/* tslint:disable */
/* eslint-disable */
/**
 * SLM API used by SLM frontend
 * This is the specification of the backend APIs. The main purpose of this specification is to unify the API between SLM-backend and SLM-frontend. For localizations the Accept-Language header is used.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dl.mhs.bd3.se@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PublishSlmBusinessEventRequest
 */
export interface PublishSlmBusinessEventRequest {
    /**
     * The business unit codes for which the event should be published.
     * Use:
     *   - `empty list` to send the event for all business units.
     *   - Specific business unit codes (e.g., `"012", "094"`) to send only for that business unit.
     * 
     */
    buCodes: Array<string>;
    /**
     * A list of unique keys for the event and single business unit codes for which the event should be published.
     * If present, buCodes must contain exactly 1 single buCode!
     * If not present, all existing keys will be published.
     * 
     */
    itemNos?: Array<string>;
    /**
     * 
     */
    entity: PublishSlmBusinessEventRequestEntityEnum;
    /**
     * The target system of the event
     * Use:
     *   - `"ALL"` to send the event to all the subscribers.
     *   - Specific system names (e.g., `"erix"`) to send only to that subscriber.
     * 
     */
    target: string;
}


/**
 * @export
 */
export const PublishSlmBusinessEventRequestEntityEnum = {
    SALES_LOCATION_CALCULATION: 'salesLocationCalculation',
    SALES_LOCATION_ASSIGNMENT: 'salesLocationAssignment',
    SALES_LOCATION_ALERT_AND_WARNING: 'salesLocationAlertAndWarning',
    SMALL_STORE_ALERT: 'smallStoreAlert',
} as const;
export type PublishSlmBusinessEventRequestEntityEnum = typeof PublishSlmBusinessEventRequestEntityEnum[keyof typeof PublishSlmBusinessEventRequestEntityEnum];


/**
 * Check if a given object implements the PublishSlmBusinessEventRequest interface.
 */
export function instanceOfPublishSlmBusinessEventRequest(value: object): value is PublishSlmBusinessEventRequest {
    if (!('buCodes' in value) || value['buCodes'] === undefined) return false;
    if (!('entity' in value) || value['entity'] === undefined) return false;
    if (!('target' in value) || value['target'] === undefined) return false;
    return true;
}

export function PublishSlmBusinessEventRequestFromJSON(json: any): PublishSlmBusinessEventRequest {
    return PublishSlmBusinessEventRequestFromJSONTyped(json, false);
}

export function PublishSlmBusinessEventRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublishSlmBusinessEventRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'buCodes': json['buCodes'],
        'itemNos': json['itemNos'] == null ? undefined : json['itemNos'],
        'entity': json['entity'],
        'target': json['target'],
    };
}

export function PublishSlmBusinessEventRequestToJSON(json: any): PublishSlmBusinessEventRequest {
    return PublishSlmBusinessEventRequestToJSONTyped(json, false);
}

export function PublishSlmBusinessEventRequestToJSONTyped(value?: PublishSlmBusinessEventRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'buCodes': value['buCodes'],
        'itemNos': value['itemNos'],
        'entity': value['entity'],
        'target': value['target'],
    };
}

